module.exports = __webpack_public_path__ + "img/Infografis_ID_16.ae2baa17.jpg";